// extracted by mini-css-extract-plugin
module.exports = {"main":"Policies_main__11di5","scrollable":"Policies_scrollable__PD-0B"};